import domains from './domains'

const isBlockedEmail = (email) => {
  const emailDomain = email.substr(email.lastIndexOf('@') + 1, email.length).toLowerCase()
  return domains.some(function (d) {
    return d.toLowerCase() === emailDomain
  })
}

const loadForm = (redirect, id, block) => {
  const { onlyBusinessEmail, errorMsg } = block

  const script = document.createElement('script')
  const safeRedirect = redirect?.trim()
  const hasCustomRedirect = Boolean(safeRedirect?.length)

  // Always dispatch marketo:success first so the popup closes on every successful submit
  // (including file downloads via followUpUrl and Craft redirects).
  // Custom Craft redirect → merge followUpUrl query params (aliId, mktoTok, …), then navigate.
  // Defer navigation with setTimeout + `return false` so other onSuccess handlers in Marketo's
  // y.onSuccess array (e.g. LeanData BookIt) run before page unload.
  // No Craft redirect → let Marketo handle followUpUrl when present (e.g. file download).
  const dispatchMarketoSuccess =
    `window.dispatchEvent(new CustomEvent('marketo:success', { detail: { formId: "${id}" } }));`

  const onSuccessBody = hasCustomRedirect
    ? `${dispatchMarketoSuccess}
       try {
         var target = new URL("${safeRedirect}", window.location.origin);
         if (followUpUrl) {
           var followUp = new URL(followUpUrl, window.location.origin);
           followUp.searchParams.forEach(function(value, key) {
             if (!target.searchParams.has(key)) target.searchParams.set(key, value);
           });
         }
         setTimeout(function() { window.location.assign(target.toString()); }, 150);
       } catch (e) {
         setTimeout(function() { window.location.assign("${safeRedirect}"); }, 150);
       }
       return false;`
    : `${dispatchMarketoSuccess}
       if (followUpUrl) { return true; }`

  script.innerHTML =
    `MktoForms2.loadForm('//get.sendbird.com', '047-LOL-803', "${ id }", function(form) {
      if (!form) return
      form.onSuccess(function(values, followUpUrl) {
        ${onSuccessBody}
      })
    })`

  const scriptHost = document.querySelector(`#script-${ id }`)
  if (!scriptHost) return
  scriptHost.append(script)

  if (!onlyBusinessEmail) return;

  const setEmailValidation = () => {
    const $form = document.querySelector(`#mktoForm_${ id }`)
    if (!$form) return
    const $email = $form.querySelector('input[type="email"]')
    if (!$email) return setTimeout(setEmailValidation, 1000)

    const $errMsg = document.createElement('span')
    $errMsg.classList.add('--err-marketo-business-email')
    $errMsg.textContent = errorMsg || 'Please enter a business address'
    $email.after($errMsg)
    const $submit = $form.querySelector('button[type="submit"]')

    $email.addEventListener('input', ({ target }) => {
      const emailValue = target.value

      if (isBlockedEmail(emailValue)) {
        $errMsg.classList.add('--active')
        $submit.setAttribute('disabled', 'true')
      } else {
        $errMsg.classList.remove('--active')
        $submit.removeAttribute('disabled')
      }

    })
  }

  setEmailValidation()
}

export default loadForm

